import { render, staticRenderFns } from "./index.vue?vue&type=template&id=472baf91"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=472baf91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TreatmentsFilter: require('/salonhomepage/client/components/treatmentsFilter.vue').default,TreatmentList: require('/salonhomepage/client/components/treatmentList.vue').default})
